import { entryPayload } from "./bulk-apply-batching";
import type { BulkApplyMergeEntry } from "./bulk-apply-merge-entry";
import type { BulkApplyCommentEntry } from "./document";
import type { TableCardEntry } from "./redline-bulk-apply-local";

type BulkApplyEntry = BulkApplyMergeEntry | BulkApplyCommentEntry | TableCardEntry;

export const BULK_APPLY_PAYLOAD_MESSAGE = "Bulk apply payload";

export interface BulkApplyPayloadStats {
    entries: number;
    totalChars: number;
    documentComments: number;
    sizesChars: number[];
}

function isMergeEntry(entry: BulkApplyEntry): entry is BulkApplyMergeEntry {
    return "target_ooxml_after" in entry;
}

function isTableCardEntry(entry: BulkApplyEntry): entry is TableCardEntry {
    return "card" in entry;
}

function payloadOf(entry: BulkApplyEntry): string {
    if (isMergeEntry(entry)) return entryPayload(entry);
    if (isTableCardEntry(entry)) return JSON.stringify(entry.card);
    return `${entry.target_text}${entry.comment_text}`;
}

export function bulkApplyPayloadStats(
    entries: BulkApplyEntry[],
): BulkApplyPayloadStats {
    const payloads = entries.map(payloadOf);
    const sizesChars = payloads.map((payload) => payload.length);
    return {
        entries: entries.length,
        totalChars: sizesChars.reduce((total, size) => total + size, 0),
        documentComments: payloads.reduce(
            (total, payload) => total + (payload.match(/<w:comment[\s>]/g) ?? []).length,
            0,
        ),
        sizesChars,
    };
}
